import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Products } from '@grandvisionhq/api-client';
import { toast } from '@grandvisionhq/common';
import { useApiConfig, useIntl } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';

const useGetFrame = ({ existingFrame , frameSlug  })=>{
    const { productsUrl  } = useApiConfig();
    const { locale  } = useIntl();
    const [frame, setFrame] = React.useState(existingFrame);
    const fetchProduct = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        try {
            const slug = typeof frameSlug === 'string' ? frameSlug : getLocalizedValue(frameSlug, locale);
            const product = yield Products.getProductBySlug(productsUrl, {
                slug
            });
            setFrame(product);
        } catch (e) {
            toast.failed('products.glasses.configurator.error');
        }
    }), [
        frameSlug,
        locale,
        productsUrl
    ]);
    React.useEffect(()=>{
        if (!frame) {
            fetchProduct();
        }
    }, [
        frame,
        fetchProduct
    ]);
    return frame;
};

export { useGetFrame };
//# sourceMappingURL=use-get-frame.js.map
